'use strict';

function ManagerInviteController(adminUserService, $location, $q) {
  var vm = this;

  vm.$onInit = $onInit;
  vm.upload = upload;

  function $onInit() {
    vm.visibility = { file: true, table: false };
    vm.unwind = 'admin/users/';
    vm.groups = [
      {id: 1, name: 'Cenceo Administrator'},
      {id: 2, name: 'Cenceo Manager'}
    ];

    vm.badGroup = false;
    vm.selectedGroups = [];
  }

  function upload(csv) {
    if (vm.selectedGroups.length === 0) {
      vm.badGroup = true;
      return $q.reject();
    } else {
      vm.badGroup = false;
    }

    return adminUserService.csvImport(csv)
      .then(function(response) {
        vm.badFile = false;
        vm.badRows =  [];
        if (response.data.bad_rows.length > 0) {
          vm.badRows = response.data.bad_rows;
          return response;
        }
        else {
          var promises = response.data.users.map(function(user) {
            user.user.groups = vm.selectedGroups;
            return adminUserService.create(user.user);
          });
          $q.all(promises).then(function(){
            $location.path(vm.unwind);
          });
        }
        return response;
      })
      .catch(function() {
        vm.badFile = true;
        vm.badRows =  [];
      });
  }
}

module.exports = ManagerInviteController;



/*****************
 ** WEBPACK FOOTER
 ** ./src/app/admin/users/manager-import/manager-import.controller.js
 ** module id = 150
 ** module chunks = 0
 **/